import { render, staticRenderFns } from "./DocumentValidationCard.vue?vue&type=template&id=44206166&scoped=true&"
import script from "./DocumentValidationCard.vue?vue&type=script&lang=js&"
export * from "./DocumentValidationCard.vue?vue&type=script&lang=js&"
import style0 from "./DocumentValidationCard.vue?vue&type=style&index=0&id=44206166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44206166",
  null
  
)

export default component.exports